class DistributorViewModel {
    getDitributorInvPrice(mPrice: any, mDiscountPrice: any, mDiscountStatus: any) {
        if (!mPrice || !mDiscountStatus) return

        if (mDiscountStatus == 'ACTIVE') {
            return mPrice - mDiscountPrice
        }

        return mPrice
    }

    getDitributorInvBeforeDiscountPrice(mPrice: any, mDiscountPrice: any, mDiscountStatus: any) {
        if (!mPrice || !mDiscountStatus) return

        if (mDiscountStatus == 'ACTIVE') {
            return mPrice
        }

        return 0
    }
}

const distributorVM = new DistributorViewModel()

export default distributorVM